export type RouterUpdateType = 'add' | 'delete';
export type RouterUpdate = {
  type: RouterUpdateType;
  key: string;
  value?: string;
};

export function addRouterKey(key: string, value: string): RouterUpdate {
  return {
    type: 'add',
    key,
    value,
  };
}

export function deleteRouterKey(key: string): RouterUpdate {
  return {
    type: 'delete',
    key,
  };
}

export function addOrDeleteRouterKey(
  key: string,
  value?: string | null | undefined
): RouterUpdate {
  return value ? addRouterKey(key, value) : deleteRouterKey(key);
}

export type UpdateRouterQueryAction = {
  type: 'ROUTER/UPDATE_QUERY';
  updates: RouterUpdate[];
};

const changePageNumber = (pageNumber: number): UpdateRouterQueryAction => ({
  type: 'ROUTER/UPDATE_QUERY',
  updates: [addOrDeleteRouterKey('page', pageNumber.toString())],
});

export const actions = {
  changePageNumber,
};
